import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import AuthGuard from "./components/AuthGuard";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Register from "./pages/Register";
import ConnectWallet from "./pages/connectwallet";
import AOS from "aos";
import "aos/dist/aos.css";
import EditProfile from "./pages/Editprofile";
import WithdrawSummary from "./pages/WithdrawSummary";
import Myteam from "./pages/Myteam";
import LevelTeam from "./pages/LevelTeam";
import ReferralTree from "./pages/ReferralTree";
import PoolChart from "./pages/PoolChart";
import DashboardNavbar from "./pages/DashboardNavbar";
import Directteam from "./pages/Directteam";
import Directincome from "./pages/Directincome";
import Levelincome from "./pages/Levelincome";
import Poolincome from "./pages/Poolincome";
import Incomeledger from "./pages/Incomeledger";
import Home from "./pages/Home";
import Loader from "./pages/Loader";
// import Loginn from "./pages/loginn";

import "bootstrap/dist/css/bootstrap.min.css";
import Activationpool from "./pages/Activationpool";
import Poolinfo from "./pages/Poolinfo";

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // once: true => only animate once
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<ConnectWallet />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/connect_wallet" element={<ConnectWallet />} />
        <Route path="/register" element={<Register />} />
        <Route path="/home" element={<Home />} />
        <Route path="/loader" element={<Loader />} />
        <Route element={<AuthGuard />}>

          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/incomeledger" element={<Incomeledger />} />
          <Route path="/editprofile" element={<EditProfile />} />
          <Route path="/withdrawsummary" element={<WithdrawSummary />} />
          <Route path="/myteam" element={<Myteam />} />
          <Route path="/level_team/:level" element={<LevelTeam />} />
          <Route path="/referraltree" element={<ReferralTree />} />
          <Route path="/poolchart" element={<PoolChart />} />
          <Route path="/dashboardnavbar" element={<DashboardNavbar />} />
          <Route path="/directteam" element={<Directteam />} />
          <Route path="/directincome" element={<Directincome />} />
          <Route path="/levelincome" element={<Levelincome />} />
          <Route path="/poolincome" element={<Poolincome />} />
          <Route path="/activationpool" element={<Activationpool />} />
          <Route path="/poolinfo" element={<Poolinfo />} />


        </Route>

      </Routes>
    </Router>
  );
}

export default App;
